import { render, staticRenderFns } from "./company-role.vue?vue&type=template&id=ebd8c64c&scoped=true&"
import script from "./company-role.vue?vue&type=script&lang=js&"
export * from "./company-role.vue?vue&type=script&lang=js&"
import style0 from "./company-role.vue?vue&type=style&index=0&id=ebd8c64c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd8c64c",
  null
  
)

export default component.exports